export default __webpack_public_path__ + "static/media/pinkSweats.65be6d34.jpeg";